import React from 'react';
import { StyledTopPanel, StyledSankeyWrapper, StyledLineWrapper } from './styled';
import Sankey from './Sankey';
import Line from './Line';

const SankeyPanel = ({ data }) => {
  return (
    <StyledTopPanel>
      <StyledSankeyWrapper>
        <Sankey data={data} />
      </StyledSankeyWrapper>
      <StyledLineWrapper>
        <Line data={data} />
      </StyledLineWrapper>
    </StyledTopPanel>
  );
};

export default SankeyPanel;
